import { render, staticRenderFns } from "./Manage-Contract-Status.vue?vue&type=template&id=bc5f3fda"
import script from "./Manage-Contract-Status.vue?vue&type=script&lang=js"
export * from "./Manage-Contract-Status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports